import { AxiosResponse } from 'axios'
import { IPaginatedResponse } from 'services/core/paginatedResponseCore'
import { DateTime } from 'services/database/reportsDatabase'
import { RequestCDU, RequestREAD } from 'services/Instances'

const TalkToUsService = () => {
  const path = 'FaleConosco'

  const getAllPaginated = async (
    request?: ITalkToUsRequestDto
  ): Promise<AxiosResponse<IPaginatedResponse<ITalkToUsResponseDto>>> =>
    await RequestREAD.get(`${path}/GetAllPaginated`, { params: request })

  const getById = async (
    idFaleConosco: number
  ): Promise<AxiosResponse<ITalkToUsEntityResponse>> =>
    await RequestREAD.get(`${path}/GetById/${idFaleConosco}`)

  const buscarHistorico = async (
    request: ITalkToUsBuscarHistoricoParams
  ): Promise<AxiosResponse<Array<ITalkToUsEntityResponse>>> =>
    await RequestREAD.get(`${path}/BuscarHistorico`,  {params: request});

  const update = async (
    request: ITalkToUsUpdateResponse
  ): Promise<AxiosResponse> =>
    await RequestCDU.put(`${path}/UpdateFaleConosco`, request)

  const post = async (
    request: ITalkToUsEntityResponse
  ): Promise<AxiosResponse> => await RequestCDU.post(`${path}/Create`, request)

  return { buscarHistorico, getAllPaginated, getById, post, update  }
}

export interface ITalkToUsBuscarHistoricoParams {
    IdUsuario: number,
    IdMotivo: number,
    CDContrato: string
}

export interface ITalkToUsRequestDto {
  idMotivo: number
  idUsuario?: number
  dtEnvioInicio: DateTime
  dtEnvioFim: DateTime
  nmUsuario?: string
  txEmail?: string
  flLiberado?: boolean
  pageNumber: number
  pageSize: number
}

export interface ITalkToUsUpdateResponse extends ITalkToUsEntityResponse {
  idUsuarioCsn: number
}

export interface ITalkToUsEntityResponse {
  faleConoscoId: number
  idParamFaleConosco: number
  dtEnvio: DateTime
  contrato: string;
  txtMensagem: string | null
  txtResposta: string | null
  idUsuario: number
}

export interface ITalkToUsResponseDto {
  idFaleConosco: number
  txMotivo: string
  nmUsuario: string
  idUsuario: number
  txEmail?: string
  dtEnvio: DateTime
  flRespondido: boolean
}

export default TalkToUsService
